/**
 * Retry utility functions
 */

import { MAX_RETRY_DELAY_MS, RETRY_BACKOFF_MULTIPLIER } from "./constants";

export function calculateRetryDelay(
  attempt: number,
  baseDelay: number,
): number {
  const exponentialDelay =
    baseDelay * Math.pow(RETRY_BACKOFF_MULTIPLIER, attempt - 1);
  return Math.min(exponentialDelay, MAX_RETRY_DELAY_MS);
}
